/**
 * Hextom QAB sometimes injects #qab_container inside #header / brand,
 * which can collapse the bar to logo-column width (esp. after paid
 * landing → logo → home). Move it above the header when trapped.
 */
(function () {
  var TRAP_SELECTOR = '#header, #mobile-header, .header__brand, .logo__content, .header__logo';

  function isTrapped(el) {
    return !!(el && el.closest && el.closest(TRAP_SELECTOR));
  }

  function placementAnchor() {
    return (
      document.getElementById('shopify-section-header__top-bar') ||
      document.getElementById('shopify-section-header-classic') ||
      document.querySelector('[id^="shopify-section-header"]') ||
      document.body.firstElementChild
    );
  }

  function placeBar() {
    var bar = document.getElementById('qab_container');
    if (!bar || !isTrapped(bar)) return;

    var anchor = placementAnchor();
    if (!anchor || !anchor.parentNode) return;
    if (bar.nextElementSibling === anchor) return;

    anchor.parentNode.insertBefore(bar, anchor);
  }

  placeBar();

  if (typeof MutationObserver === 'undefined') return;

  var scheduled = false;
  var observer = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      placeBar();
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
